import { render, staticRenderFns } from "./ServicesByCategory.vue?vue&type=template&id=b6f0747c&"
import script from "./ServicesByCategory.vue?vue&type=script&lang=js&"
export * from "./ServicesByCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports